import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'

import Button from '@/components/Button'

import {
  TicketsBody,
  TicketsCategories,
  TicketsCategoryCard,
  TicketsCategoryCardContent,
  TicketsCategoryCardImage,
  TicketsHeader,
  TicketsHeaderContent,
  TicketsLogo,
  TicketsTitle,
  TicketsView
} from '../../Tickets.styles'

export interface CategoryUiData {
  id: number | string
  name: string
  description: string
  imageUrl?: string
}

interface CategoriesProps {
  categories: CategoryUiData[]
  onSelect: (categoryId: number | string) => void
}

const Categories = ({ categories, onSelect }: CategoriesProps) => {
  const { t } = useTranslation()

  const handleSelect = (categoryId: number | string) => {
    onSelect(categoryId)
  }

  return (
    <TicketsView>
      <TicketsHeader align="center">
        <TicketsHeaderContent>
          <TicketsLogo>
            <SVG src={require('@/assets/img/logo.svg').default}></SVG>
          </TicketsLogo>
          <TicketsTitle>
            <h1>Wybierz Atrakcję</h1>
            <h3>Co chcesz zwiedzić?</h3>
          </TicketsTitle>
        </TicketsHeaderContent>
      </TicketsHeader>
      <TicketsBody>
        <TicketsCategories>
          {categories.map(category => (
            <TicketsCategoryCard key={category.id} onClick={() => handleSelect(category.id)}>
              <TicketsCategoryCardImage>
                <img src={category.imageUrl} alt={category.name} />
              </TicketsCategoryCardImage>
              <TicketsCategoryCardContent>
                <h3>{category.name}</h3>
                <p>{category.description ? parse(category.description) : '-'}</p>
                <Button variant="secondary" size="sm">
                  {t('select')}
                </Button>
              </TicketsCategoryCardContent>
            </TicketsCategoryCard>
          ))}
        </TicketsCategories>
      </TicketsBody>
    </TicketsView>
  )
}

export default Categories
